import axios from "axios";
import { API_URL } from "../../utils/api-utils";
import { common } from "../../utils";
//Master
export const GetListRoleModuleMaster = async (param) => {
  let url = `${API_URL.Lobby}/api/Portal/GetListRoleModuleMaster`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

export const SaveRoleModule = async (param) => {
    let url = `${API_URL.Lobby}/api/Portal/SaveRoleModule`;
    let { result } = await common.to(axios.post(url, param));
    if (result && result.data) return result.data;
};


  

  